module.exports = __webpack_public_path__ + "static/media/man.80f2b2b8.jpg";